import { Post } from '@/mocks/posts';
import PostCard from '@/components/base/PostCard';

interface HeroSectionProps {
  featuredPost: Post;
}

export default function HeroSection({ featuredPost }: HeroSectionProps) {
  return (
    <section className="relative w-full pt-0">
      <PostCard post={featuredPost} variant="featured" />
    </section>
  );
}
